export function sortCurrency(values: string[]) {
    return values.slice().sort((a, b) => {
        // Remove the dollar sign and commas, then convert to a number
        const numA = parseFloat(a.replace(/[$,]/g, ''));
        const numB = parseFloat(b.replace(/[$,]/g, ''));

        return numA - numB;
    });
}
